import { TableCell, TableRow } from "@braze/beacon-core"
import { AnalysisCampaignObject, CampaignObject } from "../../../types/APITypes"
import { CampaignModal } from "./modal/CampaignModal";
import { useAnalysisContext } from "../../../contexts/AnalysisContext";


type AnalysisTableRowProps = {
    campaign: AnalysisCampaignObject;
}
export const AnalysisTableRow = (({campaign} : AnalysisTableRowProps) => {
    const today = new Date();
    const {showProjections} = useAnalysisContext();

    const renderMetricCell = (liveValue: number, projectedValue: number | null) => {
        switch (showProjections) {
            case "live":
                return liveValue.toLocaleString();
            case "projections":
                return projectedValue != null ? projectedValue.toLocaleString() : "N/A";
            case "delta":
                return projectedValue != null ? (liveValue - projectedValue).toLocaleString() : "N/A";
            default:
                return liveValue.toLocaleString();
        }
    };

    const renderAmountCell = (liveValue: number, projectedValue: number | null) => {
        switch (showProjections) {
            case "live":
                return "$ " + Math.round(liveValue).toLocaleString();
            case "projections":
                return projectedValue != null ? "$ " + Math.round(projectedValue).toLocaleString() : "N/A";
            case "delta":
                return projectedValue != null ? "$ " + Math.round(liveValue - projectedValue).toLocaleString() : "N/A";
            default:
                return "$ " + Math.round(liveValue).toLocaleString();
        }
    };

    return (
        <TableRow>
            <TableCell style={{borderBottom : "0px"}}>
                <CampaignModal campaign={campaign}/>
            </TableCell>
            <TableCell>
                {campaign.fiscal_year}
            </TableCell>
            <TableCell>
                {campaign.fiscal_quarter}
            </TableCell>
            <TableCell>
                {campaign.start_date !== null ? campaign.start_date : ""} [{campaign.start_date !== null ? Math.round((today.getTime() - new Date(campaign.start_date).getTime())/(1000 * 3600 * 24)) : 0}]
            </TableCell>
            <TableCell>
                {campaign.budget_amount !== null ? "$ "+campaign.budget_amount.toLocaleString() : "N/A"}
            </TableCell>
            <TableCell>
                {renderMetricCell(campaign.nnl_count, campaign.nnl_projected_count)}
            </TableCell>
            <TableCell>
                {renderMetricCell(campaign.mql_count, campaign.mql_projected_count)}
            </TableCell>
            <TableCell>
                {renderMetricCell(campaign.sql_count, campaign.sql_projected_count)}
            </TableCell>
            <TableCell>
                {renderMetricCell(campaign.pipe_count, campaign.pipe_projected_count)}
            </TableCell>
            <TableCell>
                {renderAmountCell(campaign.pipe_amount, campaign.pipe_projected_amount)}
            </TableCell>
        </TableRow>
    )
})

